import { Pipe, PipeTransform } from '@angular/core';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';
/*
 * Dada una key pasada como argumento, retorna una
 * representacion legible.
 * Toma como argumento un string.
 *
 * Uso:
 *   key | humanize
 *
 * Ejemplo:
 *
 *   {{ 'TABLA_SIMPLE' | humanize }}
 *
 *   retorna: 'Tabla Simple'
*/
@Pipe({ name: 'humanize' })
export class HumanizePipe implements PipeTransform {

  constructor(private sxTranslationService: SxTranslationService) {
  }

  transform(key: string): string {
    const mappingKeys = {
      //#region data types
      'String': this.sxTranslationService.getResource('HUM_STRING'),
      'Decimal': this.sxTranslationService.getResource('HUM_DECIMAL'),
      'Int32': this.sxTranslationService.getResource('HUM_INT32'),
      'Int64': this.sxTranslationService.getResource('HUM_INT64'),
      'Boolean': this.sxTranslationService.getResource('HUM_BOOLEAN'),
      'Email': this.sxTranslationService.getResource('HUM_EMAIL'),
      'TABLA': this.sxTranslationService.getResource('HUM_SYSTEM_TABLE'),
      'TABLA_SIMPLE': this.sxTranslationService.getResource('HUM_SIMPLE_TABLE'),
      'LIST': this.sxTranslationService.getResource('HUM_ATTRIBUTE_LIST'),
      'Custom': this.sxTranslationService.getResource('HUM_CUSTOM'),
      'DateTime': this.sxTranslationService.getResource('HUM_DATETIME'),
      //#endregion

      //#region Provider operations
      'Quotation': this.sxTranslationService.getResource('HUM_QUOTATION'),
      'Sale': this.sxTranslationService.getResource('HUM_SALE'),
      'Endorsement': this.sxTranslationService.getResource('HUM_ENDORSEMENT'),
      'ReportGenerator': this.sxTranslationService.getResource('HUM_REPORTGENERATOR'),
      'ReportQuery': this.sxTranslationService.getResource('HUM_REPORTQUERY'),
      //#endregion

      //#region Product Report Execution types 
      'ExecuteRuleBased': this.sxTranslationService.getResource('HUM_RULE_BASED'),
      'ExecuteWordBased': this.sxTranslationService.getResource('HUM_WORD_BASED'),
      'ExecutePDFBased': this.sxTranslationService.getResource('HUM_PDF_BASED'),
      //#endregion

      //#region Column types
      'ATTRIBUTE': this.sxTranslationService.getResource('HUM_PRODUCT_COLUMN'),
      'CUSTOM': this.sxTranslationService.getResource('HUM_CUSTOM_COLUMN'),
      'DOCUMENT_COMPONENT': this.sxTranslationService.getResource('HUM_COMMON_COLUMN'),
      //#endregion

      //#region Dynamic Styles
      'short': this.sxTranslationService.getResource('HUM_EQUIVALENT_TO') + '\'M/d/yy, h:mm a\' (6/15/15, 9:03 AM)',
      'medium': this.sxTranslationService.getResource('HUM_EQUIVALENT_TO') + '\'MMM d, y, h:mm:ss a\' (Jun 15, 2015, 9:03:01 AM)',
      'long': this.sxTranslationService.getResource('HUM_EQUIVALENT_TO') + '\'MMMM d, y, h:mm:ss a z\' (June 15, 2015 at 9:03:01 AM GMT+1)',
      'full': this.sxTranslationService.getResource('HUM_EQUIVALENT_TO') +
        '\'EEEE, MMMM d, y, h:mm:ss a zzzz\' (Monday, June 15, 2015 at 9:03:01 AM GMT+01:00)',
      'shortDate': this.sxTranslationService.getResource('HUM_EQUIVALENT_TO') + '\'M/d/yy\' (6/15/15)',
      'mediumDate': this.sxTranslationService.getResource('HUM_EQUIVALENT_TO') + '\'MMM d, y\' (Jun 15, 2015)',
      'longDate': this.sxTranslationService.getResource('HUM_EQUIVALENT_TO') + '\'MMMM d, y\' (June 15, 2015)',
      'fullDate': this.sxTranslationService.getResource('HUM_EQUIVALENT_TO') + '\'EEEE, MMMM d, y\' (Monday, June 15, 2015)'
      //#endregion
    };

    return mappingKeys[key] || '';
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/pipes/humanize.pipe.ts